import React from 'react';
import { GoogleOAuthProvider, GoogleLogin } from '@react-oauth/google';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

console.log(`${API_BASE_URL}/auth/google/callback`);

const Login = ({ setUser }) => {
  const navigate = useNavigate();

  const handleGoogleSuccess = async (response) => {
    console.log("Google login success response:", response);
  
    if (!response.credential) {
      console.error("Google credential is missing or invalid.");
      return;
    }
  
    try {
      console.log(`${API_BASE_URL}/auth/google/callback`);
      const res = await axios.post(`${API_BASE_URL}/auth/google/callback`, {
        token: response.credential,
      });
  
      console.log("Server response:", res.data);
  
      // Stocker l'utilisateur et le token dans localStorage
      const userData = {
        ...res.data.user, // Données utilisateur (id, name, email, profile_pic)
        access_token: res.data.access_token, // Ajout du token pour les requêtes API
      };
      localStorage.setItem("user", JSON.stringify(userData));
  
      // Met à jour l'état utilisateur
      setUser(userData);
  
      // Redirige vers la page principale
      navigate("/sessions");
    } catch (error) {
      console.error("Error during API call:", error.response?.data || error.message);
    }
  };
  
  const handleGoogleFailure = (error) => {
    console.log("Google login failed:", error);
  };

  return (
    <div style={styles.container}>
      {/* Bandeau (Header) */}
      <div style={headerStyle}>
        <span style={logoStyle} onClick={() => navigate("/")} role="button">
          Dansy
        </span>
        <h1 style={titleStyle}>Connexion</h1>
      </div>

      {/* Contenu principal */}
      <div style={loginContentStyle}>
        <div style={styles.buttonContainer}>
          <GoogleOAuthProvider
            clientId="538374964776-musvtqu88e56gbcqnp43oo8l8gmp1b4l.apps.googleusercontent.com"
          >
            <GoogleLogin
              onSuccess={handleGoogleSuccess}
              onError={handleGoogleFailure}
              text="signin_with"
              shape="pill"
              locale="en"
            />
          </GoogleOAuthProvider>
        </div>
      </div>
    </div>
  );
};

const headerStyle = {
  width: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  background: "linear-gradient(135deg, #fff0f3, #ffd6dd)",
  color: "#000",
  padding: "15px",
  position: "fixed",
  top: 0,
  left: 0,
  right: 0,
  boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
  height: "30px",
  zIndex: 100,
};

const logoStyle = {
  position: "absolute",
  left: "20px",
  fontSize: "1.7rem",
  fontFamily: "'Shirkhand', cursive",
  color: "#ff477e",
  fontWeight: "bold",
  cursor: "pointer",
};

const titleStyle = {
  fontSize: "1.5rem",
  fontWeight: 700,
};

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100vh',
    backgroundColor: '#f5f5f5',
  },
  buttonContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
  },
};

const loginContentStyle = {
  marginTop: "70px", // espace pour compenser le header fixe
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  width: "100%",
};

export default Login;
